module.exports = __webpack_public_path__ + "public/SiteIcons/receiptIconHover.svg?d719adf3";